import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { MarkSuccessOnClick } from '@justgiving/experiments';
import classNames from 'classnames';

import config from '../../client/config';
import { Experiments } from '../../constants/experiments';
import { MODAL } from '../../context';
import { useApp, usePageMeta } from '../../hooks';
import Button from '../Button/Button';
import Modal from '../Modal/Modal';
import { TickIconFilled } from './TickIconFilled';

import styles from './ReadyToGoModal.scss';

interface ReadyToGoModalProps {
  onClose: () => void;
}

// B2C_044 - Donate to yourself
// Remove this when removing this experiment
export const ReadyToGoModal: FunctionComponent<ReadyToGoModalProps> = ({
  onClose,
}) => {
  const { showModal } = useApp();
  const { t } = useTranslation('common', { useSuspense: false });
  const { pageShortName } = usePageMeta();

  const adminLink = `${config.baseUri}/fundraising-edit/${pageShortName}/edit`;

  return (
    <Modal onCloseRequest={onClose} className={styles.modal} displayCloseButton>
      <TickIconFilled className={styles.icon} />
      <h1 className="jg-h1">{t('fundraising.readyToGo.modal.heading')}</h1>
      <p className={styles.description}>
        {t('fundraising.readyToGo.modal.description')}
      </p>
      <MarkSuccessOnClick
        testSlug={Experiments.b2c_044_donate_to_yourself}
        successType="ModalReadyToGoPersonalise"
      >
        <a
          href={adminLink}
          className={classNames(
            'jg-btn--ghost',
            'jg-btn',
            styles.button,
            styles.personalise,
          )}
        >
          {t('fundraising.readyToGo.modal.personaliseButton')}
        </a>
      </MarkSuccessOnClick>
      <MarkSuccessOnClick
        testSlug={Experiments.b2c_044_donate_to_yourself}
        successType="ModalReadyToGoShare"
      >
        <Button
          className={classNames(styles.button, styles.share)}
          onClick={() => showModal({ modal: MODAL.SHARE, overwrite: true })}
        >
          {t('common.share')}
        </Button>
      </MarkSuccessOnClick>
    </Modal>
  );
};
